import { useEffect, useState } from 'react';
import { useCalibration } from '../../../context/calibrationContext';
import { usePostMessage, useReceiveMessage } from '../../../context/messageContext';
import { CameraCalibrationView } from '../../session/calibration/ClinicianCalibrationViews';
import { useCalibrationSync } from '../../session/calibration/sync';

// Camera calibration with the blindspot method (patient seated at 50cm). Same messages as before:
// 'startPupillaryDistanceDetection' -> patient answers 'blindspotPerceivedFocalLength'.
const BlindspotCameraCalibration = ({ setStep }) => {
  const [calibrationStatus, setCalibrationStatus] = useState(0);
  const { updateCalibrationData, calibrationData } = useCalibration();
  const messageFromPatient = useReceiveMessage();
  const postMessage = usePostMessage();
  const { patchCalibration } = useCalibrationSync();

  const calibrateCamera = () => {
    setCalibrationStatus(1);
    updateCalibrationData({ cameraCalibrated: false });
    postMessage({ type: 'startPupillaryDistanceDetection', content: {} });
  };

  useEffect(() => {
    if (messageFromPatient?.type === 'blindspotPerceivedFocalLength') {
      let cameraCalibrated = true;
      if (!messageFromPatient.content.perceivedFocalLength) {
        setCalibrationStatus(0);
        cameraCalibrated = false;
      }
      updateCalibrationData({ perceivedFocalLength: messageFromPatient.content.perceivedFocalLength, cameraCalibrated: cameraCalibrated });
      patchCalibration({ camera_calibrated: cameraCalibrated });
    }
  }, [messageFromPatient, updateCalibrationData, patchCalibration]);

  useEffect(() => {
    if (calibrationData.cameraCalibrated) setCalibrationStatus(2);
  }, [calibrationData.cameraCalibrated]);

  return (
    <CameraCalibrationView
      status={calibrationStatus}
      instruction='Please wait for the patient to be positioned at 50cm, then click "Begin Calibration".'
      onBegin={calibrateCamera}
      onBack={() => {
        postMessage({ type: 'holding' });
        setStep('camera-calibration-selection');
      }}
      onNext={() => {
        postMessage({ type: 'calibration-selection' });
        setStep('calibration-selection');
      }}
    />
  );
};

export default BlindspotCameraCalibration;
